import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useSearchParams } from 'src/routes/hooks';
import Mainpage from './organizational-hierarchy-page';
// ----------------------------------------------------------------------
export default function OrganizationalHierarchyPage() {
  const searchParams = useSearchParams();
  const token = searchParams.get('token') || localStorage.getItem('authToken') || '';
  const project = searchParams.get('project_id') || localStorage.getItem('projectId') || '';
  const company = searchParams.get('company_id') || localStorage.getItem('companyId') || '';
  useEffect(() => {
    localStorage.setItem('authToken', token);
    localStorage.setItem('projectId', project);
    localStorage.setItem('companyId', company);
  }, [token]);

  return (
    <>
      <Helmet>
        <title> Organizational Hierarchy </title>
      </Helmet>
      <Mainpage />
    </>
  );
}
